import BackgroundImage from "../../components/ui/BackgroundImage";
import WeddingDocument from "./components/WeddingDocument";
import bgImg from "./assets/images/bg.webp";

export default () => {
  return (
    <BackgroundImage
      imageSrc={bgImg}
      className="h-screen flex items-center justify-center overflow-hidden"
    >
      <WeddingDocument
        title="Wedding"
        subtitle="ATLANTIS"
        description="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
        price="$50,000"
        priceLabel="Service Tax"
        priestName="Ernesto"
        priestLabel="Preotul"
        nameOptions={[
          { id: "andrei", label: "Andrei" },
          { id: "cristina", label: "Cristina" },
          { id: "no-change", label: "No Change" },
        ]}
        namePrompt="Alege un nume"
        inputPlaceholder="Type Here..."
        sendButtonText="Send"
        cancelButtonText="Cancel"
        onSend={() => alert("send")}
        onCancel={() => alert("close")}
      />
    </BackgroundImage>
  );
};
